import React from "react";
import Form from "./Form";
import { Box } from "@mui/material";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
   getQuotaStatusList,
   getUserCountries,
   reset
} from "./quotaModificationSlice";
import Loading from "./Loading";
import Table from "./Table";
import GraphModal from "./GraphModal";
import ModificationInfoTable from "./ModificationInfoTable";
import Comments from "./Comments";
import DisplayRecordsCheckbox from "./DisplayRecordsCheckbox";
import ModificationPriorTable from "./ModificationPriorTable";
import ModificationLatestTable from "./ModificationLatestTable";
import ModificationDetails from "./ModificationDetails";
import RejectModification from "./RejectModification";
import ApproveModification from "./ApproveModification";
import RejectModificationSingle from "./RejectModificationSingle";
import ApproveModificationSingle from "./ApproveModificationSingle";
import ButtonGroup from "./ButtonGroup";
import MessageForModification from "./MessageForModification";
import CollapseSection from "../../../components/ui/CollapseSection";

export default function QuotaModification() {
   const dispatch = useDispatch();
   const states = useSelector((store) => store.quotaModification);
   const {
      quotaStatusList,
      countries,
      quotaList,
      scenarioModificationList,
   } = states;

   useEffect(() => {
      dispatch(reset("refresh"));
      if (quotaStatusList.length === 0) {
         dispatch(getQuotaStatusList());
      }
      if (countries.length === 0) {
         dispatch(getUserCountries());
      }
   }, []);

   return (
      <Box>
         <Loading />
         <Box>
				<MessageForModification />
			</Box>
         <CollapseSection title="Search for quota">
         <Form />
         <br/>
         <GraphModal />
         <Box sx={{ width: "100%" }}>
         {/* {quotaList.length > 0 ?  <Table/>  : null} */}
            {quotaList.length > 0 ?  <ModificationDetails/>  : null}
         </Box>
         {quotaList.length > 0 ? <ButtonGroup/> : null}
         {scenarioModificationList !== null ? (
            <>
               {/* <ModificationInfoTable /> */}
               <ModificationPriorTable />
               <DisplayRecordsCheckbox />
               <ModificationLatestTable />
            </>
         ) : null}
         </CollapseSection>
         <CollapseSection title="Comments and attachments">
         <Comments />
         </CollapseSection>
         <RejectModification />
         <RejectModificationSingle />
         <ApproveModification />
         <ApproveModificationSingle />
      </Box>
   );
}
